export default {
   bannerBlue: '#1E3C70',
   black: '#000000',
   blue: '#0000ff',
   chalkyBlue: '#4f6b9b',
   darkGreen: '#2a7a3b',
   darkRed: '#b20000',
   forestGreen: '#146a5d',
   grey: '#444444',
   lighterGrey: '#72777F',
   lightGrey: '#f7f7f7',
   nearBlack: '#323a45',
   separatorGrey: '#d6d7d9',
   slate: '#323a45',
   smokyGrey: '#777777',
   softBlue: '#0e70b4',
   tarheelBlue: '#4f6b9b',
   white: '#FFFFFF',
};